import { render, staticRenderFns } from "./AnalyticsOpportunitySetting.vue?vue&type=template&id=5a8da8a6"
import script from "./AnalyticsOpportunitySetting.vue?vue&type=script&lang=js"
export * from "./AnalyticsOpportunitySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports